/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';
import { initialUserSettingsState } from '../../types';
import { initialHolidayState } from './holidayState';
import { initialModalState } from './modalState';
export const initialFeatureFlagsState = {};
export const ReducerContext = createContext({
    holidayState: initialHolidayState,
    holidayDispatch: ((action) => { }),
    modalState: initialModalState,
    modalDispatch: ((action) => { }),
    userSettingsState: initialUserSettingsState,
    userSettingsDispatch: ((action) => { }),
    featureFlagsState: initialFeatureFlagsState,
    featureFlagsDispatch: ((action) => { }),
});
